import { objectSpread2 as _objectSpread2, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxControl } from '../components/Form/Controls/CheckboxControl.js';
import isEmpty from 'lodash/isEmpty';
import kebabCase from 'lodash/kebabCase.js';
import { Box, Flex, Text } from '@chakra-ui/react';
import { InfoTooltip } from '../components/InfoTooltip/component.js';
import { pickDataAttributes } from '../utils/pickDataAttributes.js';
import { formatClassName as _formatClassName } from '../utils/formatClassName.js';
var getDataAction = function getDataAction(_ref) {
  var children = _ref.children,
    label = _ref.label;
  if (!(children || label)) return 'check-checkbox';
  return children ? "check-".concat(kebabCase(children)) : "check-".concat(kebabCase(label));
};
var MaterialCheckbox = function MaterialCheckbox(props) {
  var hasTooltip = !isEmpty(props.tooltip);
  var hasHelpLine = !isEmpty(props.helpLine);
  var dataAttributes = pickDataAttributes(props, 'checkbox');
  if (!dataAttributes['data-action']) {
    dataAttributes['data-action'] = getDataAction(props);
  }
  var defaultPadding = {
    pt: 0,
    pr: 4,
    pb: 0,
    pl: 0
  };
  var userPadding = props.padding || {};
  var padding = _objectSpread2(_objectSpread2(_objectSpread2({}, defaultPadding), userPadding), {}, {
    right: hasTooltip ? 0 : userPadding.pr || defaultPadding.pr
  });
  var className = _formatClassName(['checkbox', 'col-form-label', props.className, {
    'has-tooltip': hasTooltip
  }]);
  return /*#__PURE__*/React.createElement(Box, {
    as: "span",
    className: "checkbox-container"
  }, /*#__PURE__*/React.createElement(Flex, {
    align: "start",
    direction: "column"
  }, /*#__PURE__*/React.createElement(Flex, {
    align: "center"
  }, /*#__PURE__*/React.createElement(CheckboxControl, _extends({}, props, {
    padding: padding
  }, dataAttributes, {
    className: className
  }), props.children || props.label), hasTooltip && /*#__PURE__*/React.createElement(Box, {
    h: "29px"
  }, /*#__PURE__*/React.createElement(InfoTooltip, props.tooltip))), hasHelpLine && /*#__PURE__*/React.createElement(Text, {
    style: {
      margin: '-12px 0 8px 0'
    },
    fontSize: "xs",
    pl: 6
  }, props.helpLine)));
};
MaterialCheckbox.displayName = "MaterialCheckbox";
MaterialCheckbox.propTypes = {
  chakra: PropTypes.bool,
  children: PropTypes.any,
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  helpLine: PropTypes.string,
  padding: PropTypes.object,
  onChange: PropTypes.func,
  tooltip: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipPosition: PropTypes.string,
    buttonClass: PropTypes.string
  })
};
export { MaterialCheckbox };